<template lang="html">
    <div>
     
    <div class="" v-bind:id="id" v-if="hasConfig()">
  
      <div v-for="r of config.remindersId">
        <component v-if="r" v-bind:is="'bulmaReminder'" v-bind:id="r"></component>
      </div>

      <div class="is-justify-content-space-between mb-3 is-flex-tablet">
        <div><h1 class="title is-5 pr-1 pt-1">{{ config.title }}</h1></div>

        <!-- EDIT -->
        <button v-if="this.$store.getters.getRecordState != 'NEW' && !editMode" class="button is-rounded is-small">
          <span class="icon" v-on:click="enableEditMode()"><i class="fas fa-pen"></i></span>
        </button>
      </div>
  
      <div class="table-container">
  
        <!-- HEADER -->
        <div v-if="!large_screen" class="columns is-multiline is-gapless is-mobile mb-1">
          <div class="column is-text-overflow has-text-weight-bold" v-for="(col,index) in cols" v-bind:key="col.id" 
            v-bind:style="'text-align:'+align(col.format)" v-bind:class="{'is-hidden':index==0, 'is-one-third':index>0}" >
            <span>{{ col.label }}</span>
          </div>
        </div>
  
        <!--  versione columns -->
        <div v-if="!large_screen" class="columns is-multiline is-gapless is-mobile" style="border-top: 1px solid;" v-for="(record,index) in current_page_records" v-bind:key="record.id">
  
          <div class="column is-text-overflow" v-for="(col,indexF) in cols" v-bind:key="col.id" v-bind:style="'text-align:'+align(col.format)" v-bind:class="{'is-full':indexF==0, 'is-one-third':indexF>0}" >
  
              <bulmafieldcontext @change="updateRecord($event)" @select="setRecordData($event)" :id="col.name" :data="col" :record="{ ... record, process: id }" :showLabel="false" :disabledProp="!editMode" v-bind:table="config.table"></bulmafieldcontext>
              <span v-if="showAddButton(indexF)" @click="addEmptyRecord(index)"><i class="fas fa-plus"></i></span>

          </div>
          <div v-if="config.candelete && editMode" class="is-align-content-center" @click="deleteRecord(index, record.Id)"><span><i class="fas fa-trash"></i></span></div>

        </div>
        <div v-if="!large_screen && editMode && !config.orderedItem" class="mb-4" @click="addEmptyRecord(current_page_records.length-1)"><i class="fas fa-plus"></i></div>
        <!--  versione columns -->
  
        <!--  versione table -->
        <table v-if="large_screen" class="table is-narrow">
          <thead>
            <tr>
              
              <th v-for="(col, index) in cols" v-bind:key="col.id" style="vertical-align:top" >
                <span>{{  col.label }}</span>
              </th>

            </tr>
          </thead>
          <tbody>
              <tr v-for="(record,index) in current_page_records_desktop" v-bind:key="record.Id">

                <td v-for="(col, indexF) in cols" :key="col.name" class="" v-bind:style="'text-align:'+align(col.format)" :class="{'is-text-overflow': inOneLine(col.format)}" >

                  <bulmafieldcontext @change="updateRecord($event)" :id="col.name" :data="col" :record="record" :showLabel="false" :disabledProp="!editMode" v-bind:table="config.table"></bulmafieldcontext>
                  <span v-if="showAddButton(indexF)" @click="addEmptyRecord(index)"><i class="fas fa-plus"></i></span>
  
                </td>
                <td v-if="config.candelete && editMode" class="is-align-content-center" @click="deleteRecord(index, record.Id)"><span><i class="fas fa-trash"></i></span></td>
  
              </tr>
              <tr v-if="editMode && !config.orderedItem" @click="addEmptyRecord(current_page_records_desktop.length-1)"><i class="fas fa-plus"></i></tr>
          </tbody>
        </table>
        <!--  versione table -->

        <div v-if="editMode" class="has-text-left">
          <button class="button has-background-success mr-2" v-on:click="updateRecords()">Save</button>
          <button class="button" v-on:click="enableEditMode()">Cancel</button>
        </div>
  
      </div>
    
      <nav class="level" v-if="$store.state.busy">
        <div class="level-item has-text-centered">
          <button class="button is-loading" >Loading</button>
        </div>
      </nav>

      <div v-if="config.caninsert && config.usescanner && $store.state.global_state_verb != 'n'">
        <bulmaPicturesManager v-bind:id="config.usescanner.id" @send-pictures="saveCode"></bulmaPicturesManager>
      </div>

      <bulmaPagination v-if="!$store.state.busy" v-bind:maxPages="maxPages" v-bind:currentPage="currentPage"  v-on:goto="loadPage" v-on:next="loadNextPage" v-on:previous="loadPreviousPage"></bulmaPagination>
   
      <div v-if="isAdmin() && getEditProps">
        <bulmatableprops
          v-if="showModal"
          v-bind:config="config"
          v-bind:id="id"
          v-on:change="closeModal"
          v-on:close="closeModal"
          v-on:refresh="updateTable"
        ></bulmatableprops>
     
        <button class="button" v-on:click="changeShowModal()">
          <span class="icon is-small">
            <i class="fas fa-pen"></i>
          </span>
          <span>Table</span>
        </button>
      </div>
      
  
    </div>
    <div v-else-if="!hasConfig() && isAdmin() && getEditProps"> 
      <bulmatableprops
        v-if="showModal"
        v-bind:config="config ? config : {}"
        v-bind:id="id"
        v-on:change="closeModal"
        v-on:close="closeModal"
        v-on:refresh="updateTable"
      ></bulmatableprops>
      <button class="button" v-on:click="changeShowModal()">Initialise Table</button>
    </div>
      </div>
  </template>
  
  <script>
  
  import numeral from 'numeral'
  import moment from 'moment'
  import bulmatableprops from '../components/bulma_tableprops.vue'
  import bulmafieldcontext from '../components/bulma_field_context.vue'
  
  export default {
    name: 'bulmaTableWriteInline',
    components: {
      bulmatableprops, bulmafieldcontext
    },
    props: {
      id: String,
    },
    data: function () {
      return {
        records: [],
        currentPage:1,
  
        selected_list_id:[],
        checkedAllOptions: false,
  
        showInput: false,
        inputSearch: '',
        searchFilter: '',
        searchDelay: '',
  
        showModal: false,
        showModal2: false,
  
        large_screen: true,

        editMode: false,

        autoNumberField: '',
        recordsToDelete: [],
      }
    },
    watch: {
      // broadcast_message: function(newVal) { // bus message
      //   if (newVal && newVal.message) {
      //     console.log('broadcast_message:', this.broadcast_message);
      //     if (this.broadcast_message.message=='refresh') {
      //       this.loadRows();
      //     }
      //   }
      // },
      id: function(newVal, oldVal) {
        if(newVal != oldVal) this.loadComponentData()
      },
      '$store.getters.getRecordData': function(newVal, oldVal) {
        console.log('watcher getRecordData', newVal, oldVal)
        if((newVal && !oldVal) || (newVal && oldVal && newVal.Id != oldVal.Id && newVal.Id == this.$store.getters.getRecordId)) {
          console.log('watcher getRecordData ha chiamato loadRows')
          this.loadRows()
        }
      },
      // '$store.getters.getRecordId': function(newVal, oldVal) {
      //   console.log('watcher getRecordId', newVal, oldVal)
      //   if((newVal && !oldVal) || (newVal != oldVal)) {
      //     console.log('watcher getRecordId ha chiamato loadRows')
      //     this.loadRows()
      //   }
      // }
    },
    computed: {
      config: function() {
        return this.$store.getters.getObject(this.id).data;
      },
      broadcast_message: function() { // bus message
        return { message: this.$store.state.broadcast_message, payload :this.$store.state.broadcast_message_payload };
      },
      nrecbypage() {
        return this.config.nrecbypage || 10
      },
      nrecbypageDesktop() {
        return this.config.nrecbypageDesktop || 20
      },
      current_page_records: function() {
        let s=(this.currentPage-1)*this.nrecbypage;
        let e = s + this.nrecbypage
        return this.records.slice(s,e);
      },
      current_page_records_desktop: function() {
        let s=(this.currentPage-1)*this.nrecbypageDesktop;
        let e = s + this.nrecbypageDesktop
        return this.records.slice(s,e);
      },
      cols() {
        let columns = []

        this.config.cols.forEach( c => {
          if(this.fields.has(c.fieldname)) {
            let col = this.fields.get(c.fieldname)
            if(!col.disabled) col['disabled'] = c.disabled
            if(col && col.type != 'hidden') columns.push(col)
          }
        })
        return columns
        // return this.config.cols
      },
      maxPages: function() {
        let res=this.$store.getters.getRecordsList(this.id);
        if (res) {
          if(!this.large_screen) return Math.ceil(res.totalRecords/this.nrecbypage);
          else return Math.ceil(res.totalRecords/this.nrecbypageDesktop);
        }
        return 0;
      },
      checkedAll() {
        if(this.selected_list_id.length == this.current_page_records.length) return true
        if(this.checkedAllOptions) return true
        return false
      },
      numCols() {
        return ( 'is-' + Math.floor( 12 / (this.cols.length - 1) ) )
      },
      current_cols_map() {
        var map = {}
        // for(var c of this.cols) { map[c.fieldname] = c }
        for(var c of this.cols) { map[c.fieldname] = this.fields.get(c.fieldname) }
        return map
      },
      getEditProps(){
        return this.$store.getters.getEditProps;
      },
      fields: function () {
        if (!this.$store.state.database.has(this.config.table)) return [];
        let table=this.$store.state.database.get(this.config.table);
        
        let solvedfields = new Map()
        this.config.cols.forEach( f => {
          if (table.has(f.fieldname)) {
            if(table.get(f.fieldname).type != 'hidden') {
              let f2={ ...table.get(f.fieldname) }
              if (f.readonly) f2.readonly=f.readonly;
              solvedfields.set(f.fieldname,f2)
            }
          }
        });
        return solvedfields;
      },
      fieldEditMode() {
        return this.$store.getters.getRecordState=="EDIT"
      },
      incompletedRecords() {
        this.records.forEach( (r, i) => {
          if(!r.save) {
            if(i == this.records.length) return false
            return true
          }
        })
      }
    },
    mounted: function() {
      console.log('mounted table_writeinline')
      this.loadComponentData()
      if(this.config && this.config.searchSection) this.$store.commit('SET_RECORDS_STATE',{ id: this.config.process, state: 'SEARCH'})
  
      let mq=window.matchMedia("(max-width: 1100px)");
      if (mq && mq.matches) {
        this.large_screen=false;
      }
    },
    methods: {
      loadComponentData() {
        if(!this.hasConfig()){
          return;
        }
  
        if (this.config.nrecbypage) this.nrecbypage=this.config.nrecbypage;
  
        if(this.config.checkbox) {
          if(this.config.checkbox == 'multi') this.selected_list_id.push(this.$store.state.lookup_field_value)
          else this.selected_list_id = this.$store.state.lookup_field_value
        }
        console.log('this.selected_list_id',this.selected_list_id)
  
        // hydration
        if (this.config.hydration) this.hydrate();

        if(this.$store.getters.getRecordData && this.$store.getters.getRecordData.Id) this.loadRows()
      },
      isActionable: function(type) {
        if (type=='email') return true;
        if (type=='phone') return true;
        return false;
      },
      create: function() {
        // new_record
        let m={ message: 'new_record', payload: this.config.process};
        this.$store.commit('POST_MESSAGE', m);
      },
      loadNextPage: async function() {
        this.currentPage++;
      },
      loadPreviousPage: async function() {
        this.currentPage--;
      },
      loadPage: async function(p) {
        this.currentPage=p;
      },
      loadRows: async function() {
        if(!this.config) return;
        console.log('--> loadRows (bulma_table_writeinline)')
        this.records=[];
  
        let f=[ ... this.config.filters]
        console.log('loadRows filtri', f)
  
        if (this.searchFilter) f=f.concat(this.searchFilter);
  
        var advancedFilters = []
        if (this.config && this.config.searchSection && this.$store.state.advancedFilteringProperties.length > 0) {
          this.config.searchSection.forEach( s => {
            if(s.table == this.config.table) {
              f = f.concat(this.$store.state.advancedFilteringProperties.filter( f => f.table == s.table ))
            } else {
              var filters = this.$store.state.advancedFilteringProperties.filter( f => f.table == s.table )
              if(filters.length) {
                advancedFilters.push({
                  parentKey : s.parentKey,
                  tablename : s.table,
                  filters : filters
                })
              }
            }
          })
        }
        console.log('advancedFilters',advancedFilters, advancedFilters.filters)

        let cols = [... this.config.cols]
        this.cols.forEach( c => {
          if(c.related) cols.push({ fieldname: c.related })
        })
  
        var payload={
          id: this.id,
          tablename: this.config.table,
          cols: cols,
          filters: f,
          childQuery: advancedFilters.length ? advancedFilters : [],
          orders: this.config.order,
          offset: 0,
          limit: this.config.limit ? this.config.limit : 16
        }
        console.log('PAYLOAD', payload)
  
        await this.$store.dispatch('load_records', payload );
  
        let data=this.$store.getters.getRecordsList(this.id);
        if (data) {
          console.log('loadRows data',data)
          if(data.totalRecords) {
            console.log('data.totalRecords',data.totalRecords)
            this.records = data.records
          }
        }
      },
      enableEditMode() {
        this.editMode = !this.editMode
        if(this.config.defaults) this.$store.commit('SET_GLOBAL_STATE_DEFAULTS', this.config.defaults)
        if(this.config.caninsert && this.editMode) this.addEmptyRecord()
        else this.loadRows()
      },
      setRecordData(e) {
        this.$store.commit('SET_RECORDS_DATA', {id: this.id, data: e });
        this.$store.commit( 'SET_RECORDS_ID', { id: this.id, data: e.Id } );
      },
      updateRecord(e) {
        console.log('updateRecord', e)
        let record = this.records.find( r => { return r.Id == e.recordId })
        let index = this.records.indexOf(record)
        if(e.fields) {
          e.fields.forEach( (value, key) => {
            record[key] = value
          })
        }
        record['save'] = this.isComplete(record)

        if(index == this.records.length-1) this.addEmptyRecord()
      },
      saveCode(e) {
        console.log('--> saveCode writeinline', e)
        if(this.config.defaults) this.$store.commit('SET_GLOBAL_STATE_DEFAULTS', this.config.defaults)
        
        var newRecord = {}
        newRecord[this.config.usescanner.fieldname] = e
        newRecord.save = true
        newRecord.Id = 'abc'
        this.$store.dispatch('setDefaults', { record : newRecord })
        .then( resp => {
          console.log('resp', resp)
          this.records.push(newRecord)
          this.updateRecords()
          // this.loadRows()
        })
      },
      async updateRecords() {
        console.log('updateRecords')

        let procede = true
        if(this.incompletedRecords) {
          procede = confirm('You have some incompleted records. These records are going to be discard. Do you want to procede?' )
        }
        if(procede) {
          for(let record of this.records) {
            if(record.save) {
              let prop = await this.$store.dispatch('createProperties', { table: this.config.table, data: record });
              console.log('prop', prop)
              
              if(record.Id && record.Id.length < 10) {
                delete record.Id
                await this.$store.dispatch('create_record', { object: this.config.table, properties: prop, notUpdateRecord: true });
              } else {
                await this.$store.dispatch('update_record', { object: this.config.table, recordId: record.Id, properties: prop });
              }
            }
            // this.loadRows()
          }
          for(let r of this.recordsToDelete) {
            let data = {
              object: this.config.table,
              recordId: r
            }

            await this.$store.dispatch('delete_record', data);
          }
          this.editMode = false
          if(this.config.usescanner) this.loadRows()
          else location.reload() // usato per aggiornare le formule, non bellissimo ma rapido

        } else console.log('Non procede')
      },
      isComplete(record) {
        for(var f of this.fields.keys()) {
          if(this.fields.get(f).required && !record[f]) {
            return false
          }
        }
        return true
      },
      showAddButton(indexcolonna) {
        if(this.config.caninsert && this.editMode && indexcolonna == 0 && this.config.orderedItem) return true
        return false
      },
      addEmptyRecord(index) {
        let Id
        if(this.records.length > 0) Id = String(this.records.length + 1)
        else Id = String(0)

        var tmp = { Id: Id }
        this.cols.forEach( f => {
          if(!f.name.includes('.')) {
            if(f.type == 'autonumber') {
              tmp[f.name] = this.records.length+1
              this.autoNumberField = f.name
            } else tmp[f.name] = undefined
          }
        })
        this.$store.dispatch('setDefaults', { record : tmp })
        .then( resp => {
          console.log('resp', resp)
          if(index >= 0) {
            this.records.splice(index+1, 0, resp)
            for(let i = 0; i < this.records.length; i++) {
              console.log('this.records[i]',this.records[i])
              this.records[i][this.autoNumberField] = i+1
              this.records[i]['save'] = this.isComplete(this.records[i])
            }
          } else this.records.push(resp)

        })
      },
      // TODO: hydrate is for hubspot, currently broken :)
      hydrate: async function() {
        this.records=[];
  
        let records=this.$store.getters.getRecordAssoc(this.config.table);
        this.$store.commit('SET_RECORDS_DATA', { id:this.id, data:records});
        let p=[];
        this.config.cols.forEach( f => {
          if (f.fieldname!='id') p.push(f.fieldname);
        });
  
        let res=await this.$store.dispatch('hydrate_records', { id: this.id, object: this.config.table, properties:p});
        if (res.data) {
          res.data.results.forEach( (r) => {
            r.properties.id=r.id;
            this.records.push(r.properties);
          })
        }
      },
      filter: function(v, type) {
        if (!v) return v;
  
        let formato = ''
        // TODO: locale
        switch(type) {
          case 'hidden':
            return;
          case 'date':
            var d=new moment(v);
            return d.format('DD/MM/YYYY');
          case 'datetime':
            var dt=new moment(v);
            return dt.format('DD/MM/YYYY HH:mm');
          case 'decimal':
            return numeral(v).format('0,00');
          case 'currency':
            if(this.config.numberOfDecimals || this.config.numberOfDecimals==0) {
              formato = '$ 0,0.' + formato.padEnd(this.config.numberOfDecimals+formato.length, "0")
            } else formato = '$ 0,0.00'
            return numeral(v).format(formato);
            // return numeral(v).format('$ 0,0.00');
          case 'percentage':
            if(this.config.numberOfDecimals || this.config.numberOfDecimals==0) {
              formato = '0.' + formato.padEnd(this.config.numberOfDecimals+formato.length, "0")
            } else formato = '0.00'
            return numeral(v).format(formato+'%');
            // return numeral(v).format('0.00%')
          case 'alert':
            return '';
          case 'phone':
            return 'tel:'+v;
          case 'email':
            return 'mailto:'+v;
          case 'truncate':
              return v.substr(0,32);
        }
        return v;
      },
      getAddress(value) {
        if(!value) return ''
  
        var street = ''
        if(value.street) street = value.street
        if(value.city) street += ' '+value.city
        if(value.state) street += ' '+value.state
        if(value.postalCode) street += ' '+value.postalCode
  
        return street
  
      },
      inOneLine(type) {
        switch(type) {
          case 'currency': case 'phone':
            return true
        }
      },
      disabled(field) {
        if(field.readonly) return true
        if(field.disabled) return true
        if(field.hidden) return true
        return false
      },
      getFieldValue: function(obj, path) {
        console.log('--> getFieldValue')
        // eslint-disable-next-line no-redeclare
        for (var i=0, path=path.split('.'), len=path.length; i<len; i++){
          if (obj)
            obj = obj[path[i]];
        }
        return obj;
      },
      align: function(type) {
        switch(type) {
          case 'currency':
          case 'decimal':
            return 'right';
        }
        return 'left';
      },
      selectAll(checkedAll) {
        console.log(checkedAll)
        this.selected_list_id = []
        if(!checkedAll) {
          for(var r of this.current_page_records) {
            this.selected_list_id.push(r.Id)
          }
          this.saveRecords()
        }
      },
      saveRecords(record) {
        console.log('saveRecords', record)
        this.selected_list_id = record.Id
        this.$store.commit('SET_PROCESS_STATUS_DATA', {
          name: 'selected_id',
          value: record.Id,
        });
        this.$store.commit('SET_PROCESS_STATUS_DATA', {
          name: 'selected_name',
          value: record.Name,
        });
      },
      change() {
        console.log('change')
      },
      async deleteRecord(index, recordId) {
        console.log('deleteRecord',index)
        if(confirm('Do you really want to delete the record?')) {

          this.recordsToDelete.push(recordId)
          this.records.splice(index, 1)

          for(let i = 0; i < this.records.length; i++) {
            console.log('this.records[i]',this.records[i])
            this.records[i][this.autoNumberField] = i+1
            this.records[i]['save'] = this.isComplete(this.records[i])
          }
        }
      },
      isAdmin(){
        return this.$store.getters.isAdmin;
      },
      changeShowModal(){
        this.showModal=!this.showModal;
      },
      closeModal(){
        this.showModal=false;
      },
      hasConfig() {
        if(this.config){
          return true
        }else return false;
      },
      updateTable(){
        console.log("--> updateTable")
        let m={ message: 'refresh'};
        this.$store.commit('BROADCAST_MESSAGE', m);
        this.showModal=false;
      }
    }
  }
</script>
  
<style scoped>
  
  .bloccato {
    position: sticky;
    top: 0;
    z-index: 1;
  }
  .is-text-overflow {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .is-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>